import React from "react";
import "./AssessmentCriteriaTable.css";
import PropTypes from "prop-types";
import { AssessmentCriteriaInputValues } from "../../constants/Constants";

const RadioGroup = ({ name, value, onChange, yesId, noId, naId, mode }) => (
  <div
    className="field is-grouped is-grouped-multiline"
    role="radiogroup"
    aria-labelledby={`${name}-legend`}
  >
    <div className="control">
      <label className="radio">
        <input
          type="radio"
          name={name}
          id={yesId}
          value="yes"
          checked={value === "yes"}
          onChange={onChange}
          disabled={mode === "view"}
        />{" "}
        Yes
      </label>
    </div>
    <div className="control">
      <label className="radio">
        <input
          type="radio"
          name={name}
          id={noId}
          value="no"
          checked={value === "no"}
          onChange={onChange}
          disabled={mode === "view"}
        />{" "}
        No
      </label>
    </div>
    <div className="control">
      <label className="radio">
        <input
          type="radio"
          name={name}
          id={naId}
          value="not_attempted"
          checked={value === "not_attempted"}
          onChange={onChange}
          disabled={mode === "view"}
        />{" "}
        Not attempted
      </label>
    </div>
  </div>
);

// Maps value to display string for view mode
const getDisplayForAchieved = (val) => {
  if (val === AssessmentCriteriaInputValues.YES) return "Yes";
  if (val === AssessmentCriteriaInputValues.NO) return "No";
  if (val === AssessmentCriteriaInputValues.NOT_ATTEMPTED) return "Not attempted";
  return "";
};

const AssessmentCriteriaTable = ({
  values,
  notes,
  onChangeValue,
  onChangeNote,
  tableId = "tblCandidateMarksEntry",
  className = "",
  criteriaDetails: criteriaRows,
  mode = "edit",
}) => {
  const safeValues = values || {};
  const safeNotes = notes || {};

  return (
    <div className="actualassessmenttable" >
      <div className="table-scroll-x">
        <table
          id={tableId}
          className={`table is-hoverable xis-bordered is-fullwidth is-vcentered ${className}`.trim()}
        >
          <thead>
            <tr>
              <th>Assessment criteria</th>
              <th>Description</th>
              <th>Has the candidate achieved the assessment criteria?</th>
              <th>Evidence location / notes (optional)</th>
            </tr>
          </thead>
          <tbody>
            {criteriaRows.map((row, idx) => {
              const yesId = `acmark_${idx + 1}`;
              const noId = `${yesId}_no`;
              const naId = `${yesId}_na`;
              const current = safeValues[row.assessmentCriteriaName] || "";
              const noteVal = safeNotes[row.assessmentCriteriaName] || "";

              return (
                <tr key={row.assessmentCriteriaName}>
                  <td>{row.assessmentCriteriaName}</td>
                  <td>{row.assessmentCriteriaDescription}</td>
                  <td>
                    {mode === "view" ? (
                      <span>{getDisplayForAchieved(current)}</span>
                    ) : (
                      <RadioGroup
                        name={row.assessmentCriteriaName}
                        value={current}
                        yesId={yesId}
                        noId={noId}
                        naId={naId}
                        onChange={(e) =>
                          onChangeValue &&
                          onChangeValue(row.assessmentCriteriaName, e.target.value)
                        }
                        mode={mode}
                      />
                    )}
                  </td>
                  <td className="p-0">
                    <div className="textarea-wrapper" style={{ position: "relative" }}>
                      <textarea
                        className="textarea"
                        rows={2}
                        maxLength={250}
                        value={noteVal}
                        onChange={(e) =>
                          !["view"].includes(mode) &&
                          onChangeNote &&
                          onChangeNote(row.assessmentCriteriaName, e.target.value)
                        }
                        aria-label={`${row.assessmentCriteriaName} evidence location / notes`}
                        disabled={mode === "view"}
                      />
                      {mode !== "view" && (
                      <span
                        className="char-counter"
                        style={{
                          position: "absolute",
                          bottom: "4px",
                          right: "8px",
                          fontSize: "12px",
                          color: "#666",
                        }}
                      >
                        {noteVal.length}/250
                      </span>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AssessmentCriteriaTable;

AssessmentCriteriaTable.propTypes = {
  values: PropTypes.object,
  notes: PropTypes.object,
  onChangeValue: PropTypes.func,
  onChangeNote: PropTypes.func,
  tableId: PropTypes.string,
  className: PropTypes.string,
  criteriaDetails: PropTypes.array
};

